<template>
  <b-row>
    <b-col sm="12" xl="8" lg="8" md="7">
      <base-card :loading="loading"
                 v-show="!disabledTemplate">
        <h6 class="text-muted mb-3">{{ $t('pages.template_builder.template_properties') }} </h6>
        <b-tabs lazy nav-class="nav-tabs-custom"
                v-model="langTabs"
                :key="selectedType"
        >
          <!-- Render Tabs, supply a unique `key` to each tab -->
          <b-tab v-for="(lang, index) in $v.tabs.$model" :key="lang.id" :title="'Tab ' + lang.id">
            <template #title>
                <span v-show="!disabledTemplate">
                  <span :class="`flag-icon flag-icon-${languageValues[lang.value].country}`"> </span>
                 {{ languageValues[lang.value].name }}
                </span>
            </template>
            <b-card-body>
              <b-row>
                <b-col sm="6">
                  <div class="mb-3">
                    <b-form-group
                        :label="$t('pages.template_builder.subject')"
                        label-for="subject">
                      <b-form-input
                          :disabled="disabledSubject"
                          id="subject"
                          :dir="lang.hasOwnProperty('rtl') ? 'rtl' : ''"
                          v-model="lang.subject"
                          type="text"
                          class="form-control"
                          :placeholder="$t('pages.template_builder.subject_placeholder')"
                          :class="{'is-invalid': submitted && $v.tabs.$each.$iter[index].subject.$error}">
                      </b-form-input>
                      <div
                          v-if="submitted && !$v.tabs.$each.$iter[index].subject.required"
                          class="invalid-feedback"
                      >
                        {{ $t('pages.template_builder.validations.subject_required') }}
                      </div>
                      <div
                          v-if="submitted && !$v.tabs.$each.$iter[index].subject.minLength"
                          class="invalid-feedback"
                      >
                        {{
                          $t('pages.template_builder.validations.subject_min', {value: $v.tabs.$each.$iter[index].subject.$params.minLength.min})
                        }}
                      </div>
                      <div
                          v-if="submitted && !$v.tabs.$each.$iter[index].subject.maxLength"
                          class="invalid-feedback"
                      >
                        {{
                          $t('pages.template_builder.validations.subject_max', {value: $v.tabs.$each.$iter[index].subject.$params.minLength.max})
                        }}
                      </div>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col sm="6">
                  <b-row align-h="end">
                    <b-col xl="6" lg="6" md="12" sm="12" class="mb-3">
                      <b-form-group
                          :label="$t('pages.template_builder.preview_email')"
                          label-for="preview-btn"
                      >
                        <b-btn class="w-100"
                               @click="handlePreview(lang)"
                               variant="success"
                               id="preview-btn">
                          <i class="mdi mdi-file-find btn-icon icon-left"></i>
                          {{ $t('pages.template_builder.preview_email_btn') }}
                        </b-btn>
                      </b-form-group>
                    </b-col>
                    <!--                    <b-col xl="4" lg="4" md="8" sm="12" class="mb-3">-->
                    <!--                      <b-form-group-->
                    <!--                          :label="$t('pages.template_builder.send_test_email')"-->
                    <!--                          label-for="test-email-btn"-->
                    <!--                      >-->
                    <!--                        <b-btn class="w-100" id="test-email-btn" @click="sendTestEmail" variant="success"><i-->
                    <!--                            class="mdi mdi-send btn-icon icon-left"></i>-->
                    <!--                          {{ $t('pages.template_builder.send_test_email_btn') }}-->
                    <!--                        </b-btn>-->
                    <!--                      </b-form-group>-->
                    <!--                    </b-col>-->
                    <b-col xl="6" lg="6" md="12" sm="12" class="mb-3">
                      <b-form-group
                          :label="$t('pages.template_builder.remove_lang')"
                          label-for="remove-btn"
                      >
                        <b-btn class="w-100"
                               id="remove-btn"
                               variant="danger"
                               :disabled="lang.value === 'en'"
                               @click="removeLanguage(lang.value)">
                          <i class="mdi mdi-delete btn-icon icon-left"></i>
                          {{ $t('pages.template_builder.remove_lang_btn') }}
                        </b-btn>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col sm="12">
                  <div>
                    <b-form-group
                        :label-for="lang.value"
                        :label="$t('pages.template_builder.template')">
                      <editor
                          :class="{ 'editor-invalid': submitted && $v.tabs.$each.$iter[index].content.$error }"
                          :id="lang.value"
                          :lang="lang.value"
                          :disabled="disabledTemplate"
                          :currentInstance="currentInstance"
                          ref="templateEditor"
                          @open="openTemplateVariableModal"
                          v-model="lang.content"
                          :toolbarDisabled="selectedType"
                          @editorInstances="handleEditorInstances($event, lang.value)">
                      </editor>
                    </b-form-group>
                    <div
                        v-if="submitted && !$v.tabs.$each.$iter[index].content.maxLength"
                        class="invalid-feedback d-flex mt-2"
                    >
                      {{
                        $t('pages.template_builder.validations.template_max', {value: $v.tabs.$each.$iter[index].content.$params.maxLength.max})
                      }}
                    </div>
                  </div>
                </b-col>
                <div class="mt-3">
                  <a href="https://m.media-amazon.com/images/G/01/SellerCentral/CommunicationGuidelines/en_US_Communication_Guidelines.pdf"
                     target="_BLANK">
                    {{ $t('pages.template_builder.check') }}
                  </a>
                  <span>{{ $t('pages.template_builder.guideline') }}</span>
                </div>
              </b-row>

            </b-card-body>
          </b-tab>

          <template #tabs-end>
            <b-nav-item v-show="!disabledTemplate"
                        :disabled="languages.length === tabs.length"
                        role="presentation"
                        @click.prevent="newTab"
                        href="#">
              <b>+</b>
            </b-nav-item>
          </template>
        </b-tabs>
      </base-card>

      <div v-if="selectedType === 'warranty'">
        <warranty-request @warranty="warranty = $event"/>
      </div>

      <b-card v-show="!disabledLogo || !disabledAttachment">
        <h6 class="text-muted mb-3">{{ $t('pages.template_builder.template_files') }}</h6>

        <b-card-body>
          <b-row>
            <b-col sm="6" v-show="!disabledLogo">
              <b-form-group :label="$t('pages.template_builder.logo')" label-for="logo">
                <file-upload
                    :disabled="disabledLogo"
                    :initial="initialLogo"
                    @file="handleLogo"
                    :type="selectedType"
                    id="logo"
                    :options="logoFileOptions"/>
              </b-form-group>
            </b-col>

            <b-col :sm="!disabledLogo ? '6' : '12'" v-show="!disabledAttachment">
              <b-form-group :label="$t('pages.template_builder.attachment') " label-for="attachment">
                <file-upload
                    :type="selectedType"
                    :disabled="disabledAttachment"
                    id="attachment"
                    :initial="initialAttachment"
                    @file="handleAttachment"
                    :options="attachmentFileOptions"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col sm="12" xl="4" lg="4" md="5">
      <base-card :loading="loading">
        <h6 class="text-muted mb-3">{{ $t('pages.template_builder.template_information') }}</h6>
        <b-card-body class="pb-0">
          <b-row>
            <b-col sm="12" class="mb-3">
              <b-form-group
                  label-for="template-name"
                  :label="$t('pages.template_builder.template_name')"
              >
                <b-form-input
                    :placeholder="$t('pages.template_builder.template_name_placeholder')"
                    id="template-name"
                    v-model="templateName"
                    class="form-control"
                    :class="{'is-invalid': (submitted && $v.templateName.$error) || (templateNameErrors && templateNameErrors.length > 0)}"
                >
                </b-form-input>
              </b-form-group>
              <div
                  v-for="err in templateNameErrors" :key="err"
                  class="invalid-feedback d-block"
              >
                {{ err }}
              </div>
              <div
                  v-if="submitted && !$v.templateName.required"
                  class="invalid-feedback"
              >
                {{ $t('pages.template_builder.validations.template_name_required') }}
              </div>
              <div
                  v-if="submitted && !$v.templateName.minLength"
                  class="invalid-feedback"
              >
                {{
                  $t('pages.template_builder.validations.template_name_min', {min: $v.templateName.$params.minLength.min})
                }}
              </div>
              <div
                  v-if="submitted && !$v.templateName.maxLength"
                  class="invalid-feedback"
              >
                {{
                  $t('pages.template_builder.validations.template_name_max', {max: $v.templateName.$params.maxLength.max})
                }}
              </div>
            </b-col>
            <b-col sm="12" class="mb-3">
              <b-row>
                <b-col sm="12">
                  <b-form-group label="Type" label-for="type-select">
                    <b-form-select
                        :disabled="disableType"
                        id="type-select"
                        class="form-control"
                        :options="typeOptions"
                        value-field="value"
                        v-model="selectedType"
                        text-field="name"/>
                  </b-form-group>
                </b-col>
                <b-col sm="12" v-if="selectedType">
                  <b-alert class="mt-3" show>
                    <i class="mdi mdi-bullseye-arrow me-2"></i>
                    {{ typeInformation[selectedType].alert }}
                  </b-alert>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-body class="pt-0">
          <b-btn variant="primary" class="w-100" @click="submitTemplate" :disabled="btnLoading">
            <b-spinner v-if="btnLoading" small class="mx-1"></b-spinner>
            <i class="mdi mdi-content-save btn-icon icon-left"></i>
            {{
              !selectedTemplateId
                  ? $t('pages.template_builder.create')
                  : $t('pages.template_builder.update')
            }}
          </b-btn>
        </b-card-body>
      </base-card>
    </b-col>
    <email-lang-select @selectedLang="addLanguage" :availableLangs="availableLangs"/>
    <email-preview :selectedTemplate.sync="selectedTemplate"/>
    <template-variable-modal @addVariable="handleVariable" :type="selectedType"/>
  </b-row>
</template>
<script>
import EmailLangSelect from "./EmailLangSelect";
import EmailPreview from "./EmailPreview";
import FileUpload from "./File/FileUpload";
import EmailService from "../../../Services/Api/EmailService";
import CountriesMixin from "../../../mixins/CountriesMixin";
import Editor from "./Editor/Editor";
import TemplateVariableModal from "./Editor/TemplateVariableModal";
import Vue2Filters from "vue2-filters";
import SweatAlertMixin from "./Editor/Mixins/SweatAlertMixin";
import EditorDataMixin from "./Editor/Mixins/EditorDataMixin";
import WarrantyRequest from "./Types/WarrantyRequest";
import QuotaAlert from "../../../mixins/QuotaAlert";

export default {
  name: 'TemplateBuilder',
  mixins: [CountriesMixin, Vue2Filters.mixin, SweatAlertMixin, EditorDataMixin, QuotaAlert],
  components: {
    WarrantyRequest,
    TemplateVariableModal,
    FileUpload,
    EmailLangSelect,
    EmailPreview,
    Editor
  },
  page() {
    return {
      title: this.$t('pages.template_builder.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      title: this.$t('pages.template_builder.title'),
      items: [
        {
          text: this.$t('pages.template_builder.items.first'),
          href: '/templates',
        },
        {
          text: this.$t('pages.template_builder.items.second'),
          active: true,
        },
      ],
      submitted: false,
      templateName: '',
      logo: null,
      attachment: null,
      initialLogo: null,
      initialAttachment: null,
      loading: true,
      langTabs: null,
      selectedTemplate: null,
      editorInstances: {},
      currentInstance: null,
      warranty: 1,
      tabs: [],
      tabCount: 0,
      disableType: false,
      selectedType: 'customEmail',
      cache: {},
      languagesCache: [],
      templateNameErrors: [],
      selectedTemplateId: null,
      templateLoaded: false,
      btnLoading: false
    }
  },
  watch: {
    selectedType(val, old) {
      if (this.templateLoaded) {
        if (this.cache[val]) {
          this.languages = this.cache[val].languages
          this.tabs = this.cache[val].tabs
          this.tabCount = this.cache[val].tabCount
        } else {
          this.cache[old] = {
            tabs: this.tabs,
            tabCount: this.tabCount,
            languages: this.languages
          }
          this.languages = this.languagesCache
          this.tabs = []
          this.tabCount = 0
          this.emptyTemplate()
        }
      }
    }
  },
  methods: {
    addLanguage(e) {
      e.id = this.tabCount++
      this.tabs.push(e)
    },
    newTab() {
      this.$bvModal.show('email-lang-modal')
    },
    openTemplateVariableModal() {
      this.$bvModal.show('template-variable-modal')
    },
    handleVariable(variable) {
      const editor = this.editorInstances[this.currentLang]
      editor.model.change(writer => {
        const text = ' ' + variable
        editor.model.insertContent(writer.createText(text), editor.model.document.selection, 'in');
      })
      this.$bvModal.hide('template-variable-modal')
    },
    handlePreview(template) {
      this.selectedTemplate = template
      this.$bvModal.show('email-preview-modal')
    },
    handleEditorInstances(instance, lang) {
      this.editorInstances[lang] = instance
    },
    handleLogo(e) {
      this.logo = e && e.length > 0 ? e[0]?.file : null
    },
    handleAttachment(e) {
      this.attachment = e && e.length > 0 ? e[0]?.file : null
    },
    async getEmail(id) {
      this.disableType = true
      const {data: email} = await EmailService.show({id})
      this.templateName = email.data.name
      this.initialLogo = email.data?.logo
      this.initialAttachment = email.data?.attachment
      this.selectedType = email.data?.type
      this.warranty = email.data?.warranty_period ?? 1

      if (email.data.templates.length > 0) {
        email.data.templates.forEach(item => {
          item.id = this.tabCount++
          this.tabs.push(item)
        })
      } else {
        this.emptyTemplate()
      }
    },
    async submitTemplate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.btnLoading = true
        const templates = []
        this.tabs.forEach(item => {
          templates.push({
            content: item.content ?? null,
            subject: item.subject ?? null,
            lang: item.value
          })
        })

        const formData = new FormData()
        formData.append('templateName', this.templateName)
        formData.append('templates', JSON.stringify(templates))
        formData.append('type', this.selectedType)

        if (this.selectedType === 'warranty') {
          formData.append('warranty_period', this.warranty)
        }

        if (this.logo) {
          formData.append('logo', this.logo)
        }
        if (this.attachment) {
          formData.append('attachment', this.attachment)
        }
        if (!this.selectedTemplateId) {
          await EmailService.store({payload: formData}).then(() => {
            this.$router.push({name: 'templates'})
          }).catch(err => {
            if (err.status === 402) {
              this.showQuotaError()
            }
            this.templateNameErrors = err.data?.errors?.templateName
          }).then(() => {
            this.$store.dispatch('quota/getSubscriptionQuota')
          })
        } else {
          await EmailService.update({id: this.selectedTemplateId, payload: formData}).catch(err => {
            this.templateNameErrors = err.data.errors?.templateName
          })
        }
        this.btnLoading = false
      }
    },
    emptyTemplate() {
      const val = this.languages[0]
      val.id = this.tabCount++
      this.tabs.push(val)
    },
    async handle() {
      this.selectedTemplateId = this.$route.params.emailID
      this.selectedTemplateId ? await this.getEmail(this.selectedTemplateId) : this.emptyTemplate()
    },
  },
  async created() {
    this.languagesCache = JSON.parse(JSON.stringify(this.languages))
    await this.handle().finally(() => {
      this.loading = false
      this.templateLoaded = true
    })
  }
}
</script>
<style scoped>
.icon-left {
  margin-right: 3px;
}

.editor-invalid {
  border: 1px solid #f46a6a;
}
</style>

